import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import axios from "../../axios/defaultAxios";
import { errorMessage } from "../actions/messages.actions";

const ENDPOINT = "/users/v2";

/****** Get user permissions ******/

const getUserPermissions = ({ roles }) => {
  const permissions = roles
    .reduce((acc, role) => [...acc, ...role.permissions], [])
    .map((permission) => ({
      resource: permission.resource,
      action: permission.action,
    }));
  return _.unionWith(permissions, _.isEqual);
};

export const requestUserPermissions = createAsyncThunk(
  `${slices.authorization}/requestUserPermissions`,
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}/permissions`);
      if (response.status === 200) return getUserPermissions(response.data.data);
      throw new Error(response.data?.error);
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error || error.message));
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const requestUserPermissionsStatus = {
  [requestUserPermissions.fulfilled]: (state, action) => {
    state.loading = false;
    state.permissions = action.payload;
  },
  [requestUserPermissions.pending]: (state, action) => {
    state.loading = true;
  },
  [requestUserPermissions.rejected]: (state, action) => {
    state.loading = false;
  },
};
